import loadable from '@loadable/component';

export const SignupPageLoadable = loadable(() => import('./SignupPage'), {
  resolveComponent: (module) => module.SignupPage,
});
